export const LOG_PREFIX = '@sentry/instrumentation-http';
export const HTTP_ON_CLIENT_REQUEST = 'http.client.request.created';
export const HTTP_ON_SERVER_REQUEST = 'http.server.request.start';
export type ClientSubscriptionName = typeof HTTP_ON_CLIENT_REQUEST;
export type ServerSubscriptionName = typeof HTTP_ON_SERVER_REQUEST;
